import React, { Component } from 'react';
import { Route, Switch, HashRouter, BrowserRouter } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import Login from './login/Login';
import ResetPassword from './login/ResetPassword';
import Authentication from './login/Authentication';
import '../css/style.css';
import { connect } from 'react-redux';
import * as consts from './static/constants';
import { getBrowserLocaleLanguage } from './utils/defaults'
import Password from './login/Password';
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: 'React'
    };
  }

  render() {
    return (
      <HashRouter basename="/ui">
        <Switch>
          <Route path={"/"} exact render={() => <Login {...this.props} />} />
          <Route path={"/password"} exact render={() => <Password {...this.props} />} />
          <Route path={"/reset/token/:token"} exact render={() => <ResetPassword {...this.props} />} />
          <Authentication {...this.props} />
        </Switch>
      </HashRouter>
    );
  }
}
const mapStateToProps = state => {
  return {
    items: state.items,
    config: state.config,
    search: state.search
  }
}
const mapDispatchToProps = dispatch => {
  return {
    addToConfig: (value) =>
      dispatch({
        type: 'ADD_CONFIG',
        value: value
      }),
    addItem: (key, value) =>
      dispatch({
        type: 'ADD_ITEM',
        key: key,
        value: value
      }),
    logout: () =>
      dispatch({
        type: 'USER_LOGOUT'
      }),
    unload: () =>
      dispatch({
        type: 'UNLOAD',
        key: "loading",
        value: false
      }),
    load: () =>
      dispatch({
        type: 'LOAD',
        key: "loading",
        value: true
      }),
    log: (data) => {
      console.log(data);
    },
    addSearchItems: (key, value) =>
      dispatch({
        type: 'SET_SEARCH_ITEM',
        key: key,
        value: value
      }),
    clearSearchItems: (key) =>
      dispatch({
        type: 'CLEAR_SEARCH_ITEM',
        key: key
      }),
    reactTable: () => {
      return {
        pageSize: consts.defaultPageSize,
        pageSizeMini: consts.defaultPageSizeMini
      }
    },
    _formatDate: (pDate) => {
      if (pDate !== null && pDate !== "") {
        let givenDate = new Date(pDate);
        return (("0" + (givenDate.getMonth() + 1)).slice(-2) + '/' + ("0" + givenDate.getDate()).slice(-2) + '/' + givenDate.getFullYear());
      }
      return pDate;
    },
    _timeStampToNonFormatDate: (pDate) => {
      if (pDate !== null && pDate !== "") {
        let givenDate = new Date(pDate);
        return (givenDate.getFullYear() + "-" + ("0" + (givenDate.getMonth() + 1)).slice(-2) + '-' + ("0" + givenDate.getDate()).slice(-2));
      }
      return pDate;
    },
    _timeStampToDate: (pDate) => {
      if (pDate !== null && pDate !== "") {
        let givenDate = new Date(pDate);
        return (("0" + (givenDate.getMonth() + 1)).slice(-2) + '/' + ("0" + givenDate.getDate()).slice(-2) + '/' + givenDate.getFullYear());
      }
      return pDate;
    },
    _currentDate: () => {
      let today = new Date();
      return (today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate());
    },
    _currencyFormat: (pValue, comma = false) => {
      pValue = (pValue === undefined || pValue === "" || pValue === null) ? 0 : parseFloat(pValue);
      if (!Number.isNaN(Number(pValue))) {
        return new Intl.NumberFormat(getBrowserLocaleLanguage(), { minimumFractionDigits: 2 }).format(pValue)
      }
    },
    _padString: (pString, digits = 4) => {
      pString = (pString === undefined || pString === "" || pString === null) ? "" : pString.toString();
      return (pString).slice(-digits).padStart(pString.length, '*')
    },
    _ifNull: (pValue, rValue) => {
      return pValue === null || pValue === undefined ? rValue : pValue
    },
    _ifEmpty: (pValue, rValue) => {
      return pValue === null || pValue.length === 0 ? rValue : pValue
    },
    _customFilter: (filter, row) => {
      const id = filter.pivotId || filter.id;
      return (row[id] && row[id] !== undefined
        ? String(row[id].toString().toLowerCase()).includes(filter.value.toLowerCase())
        : true);
    },
    _errorItems: (pFields) => {
      let requiredFields = pFields;
      let errorMessage = [];
      if (Object.keys(requiredFields).length > 0) {
        for (let key in requiredFields) {
          if (!requiredFields[key]) {
            errorMessage.push(key);
          }
        }
      }
      return errorMessage;
    },
    _menuIsRestricted: (menuItems, menuParentId, menuId) => {
      let isRestriction = true;
      if (menuItems.length > 0) {
        menuItems.forEach((menuItem) => {
          if (menuItem.id === menuParentId) {
            if (menuItem.child.length > 0) {
              menuItem.child.forEach((menu) => {
                if (menu.id === menuId) {
                  isRestriction = false;
                }
              });
            }
          }
        });
      }
      return isRestriction;
    },
    _clientRestriction: (clients, client, attribute) => {
      let isRestriction = false;
      if (clients.length > 0) {
        clients.forEach((clt) => {
          if (client === clt.value) {
            isRestriction = !clt[attribute];
          }
        })
      }
      return isRestriction;
    }
  }
}

/** EDGE IE11 doesn't have padStart by default */
if (!String.prototype.padStart) {
  // eslint-disable-next-line
  String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
    padString = String((typeof padString !== 'undefined' ? padString : ' '));
    if (this.length > targetLength) {
      return String(this);
    }
    else {
      targetLength = targetLength - this.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
      }
      return padString.slice(0, targetLength) + String(this);
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(App));


// WEBPACK FOOTER //
// ./src/app/App.js